import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ShipmentWaybillItemState } from './shipment-waybill-item.state';
import { WaybillIdView } from '../../../models';
import { Store } from '@ngxs/store';
import {
  ShipmentWaybillCustomsDocumentsCountLoad,
  ShipmentWaybillItemNotificationListCountLoad,
  ShipmentWaybillItemSetIdentifier,
  ShipmentWaybillItemSetInitial,
  ShipmenWaybillDemurrageAndDetentionTabAvailability,
} from './shipment-waybill-item.actions';

@Injectable({ providedIn: 'root' })
export class ShipmentWaybillItemFacade {
  shipmentWaybillIdentifier$: Observable<WaybillIdView> = this.store.select(
    ShipmentWaybillItemState.getWaybillIdentifier,
  );

  documentsCount$: Observable<number> = this.store.select(
    ShipmentWaybillItemState.getShipmentWaybillCustomsDocumentsCount,
  );

  notificationListCount$: Observable<number> = this.store.select(
    ShipmentWaybillItemState.getShipmentWaybillHasNotification,
  );

  demurrageAndDetentionAvailable$: Observable<boolean> = this.store.select(
    ShipmentWaybillItemState.getDemurrageAndDetentionAvailability,
  );

  loaded$: Observable<boolean> = this.store.select(ShipmentWaybillItemState.getLoaded);

  tabsLoaded$: Observable<boolean> = this.store.select(ShipmentWaybillItemState.getTabsLoaded);

  constructor(private store: Store) {}

  setShipmentWaybillIdentifier(identifier: WaybillIdView): void {
    this.store.dispatch(new ShipmentWaybillItemSetIdentifier(identifier));
  }

  loadShipmentWaybillCustomsDocumentsCount(identifier: WaybillIdView): void {
    this.store.dispatch(new ShipmentWaybillCustomsDocumentsCountLoad(identifier));
  }

  loadShipmentWaybillNotificationListCount(identifier: WaybillIdView): void {
    this.store.dispatch(new ShipmentWaybillItemNotificationListCountLoad(identifier));
  }

  loadShipmentWaybillDemurrageAndDetentionTabAvailability(internalWaybillId: string): void {
    this.store.dispatch(new ShipmenWaybillDemurrageAndDetentionTabAvailability(internalWaybillId));
  }

  setInitialState(): void {
    this.store.dispatch(new ShipmentWaybillItemSetInitial());
  }
}
